<template>
  <el-card class="booking-setup-form mb-4" shadow="hover">
    <div slot="header" class="clearfix">
      <span class="font-weight-bold title">Thiết lập Booking cho Product</span>
    </div>
    <el-form
      ref="form"
      v-loading="submitting"
      :model="form"
      :rules="rules"
      label-width="140px"
      label-position="top"
      size="small"
    >
      <el-form-item label="Organization ID">
        <el-input v-model="form.organization_id" disabled placeholder="Org ID" />
      </el-form-item>

      <el-form-item label="Mã Product (Code)">
        <el-input v-model="form.code" disabled placeholder="Mã tự động sinh" />
      </el-form-item>

      <el-form-item label="Loại Product (Type)">
        <el-select v-model="form.type" style="width: 100%;">
          <el-option
            v-for="(val, key) in productTypes"
            :key="key"
            :label="key"
            :value="val"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="Giá cơ bản (Base Price)" prop="base_price">
        <el-input-number
          v-model="form.base_price"
          :min="0"
          :step="1000"
          style="width: 100%;"
          placeholder="Nhập giá cơ bản"
        />
      </el-form-item>

      <el-form-item label="Đơn vị tiền tệ (Currency)">
        <el-select v-model="form.currency" style="width: 100%;">
          <el-option label="VND (Đồng Việt Nam)" value="VND" />
          <el-option label="USD (Đô la Mỹ)" value="USD" />
          <el-option label="EUR (Euro)" value="EUR" />
        </el-select>
      </el-form-item>

      <el-form-item label="Yêu cầu đặt trước (Requires Prebook)">
        <el-switch v-model="form.requires_prebook" active-text="Có" inactive-text="Không" />
      </el-form-item>

      <el-form-item label="Chế độ sức chứa (Capacity Mode)">
        <el-select v-model="form.capacity_mode" style="width: 100%;">
          <el-option
            v-for="(val, key) in capacityModes"
            :key="key"
            :label="key === 'UNLIMITED' ? 'Không giới hạn (Unlimited)' : 'Giới hạn (Finite)'"
            :value="val"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-check" :loading="submitting" @click="handleSetup">
          Setup Booking
        </el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import CONSTANTS from '@/config/constants'
import { createProduct } from '@/services/product'
import { getAccountOrg } from '@/utils/filters'
import { loginInfo } from '@/services/auth'

export default {
  name: 'BookingSetupForm',
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  data() {
    const org = getAccountOrg()
    const user = loginInfo() ? loginInfo().auth_user : null
    const defaultOrg = (org && org.id) || (user && user.organization_id) || (user && user.id) || ''
    return {
      submitting: false,
      productTypes: CONSTANTS.PRODUCT_TYPE || { TOUR: 'tour' },
      capacityModes: CONSTANTS.CAPACITY_MODE || { UNLIMITED: 'unlimited', FINITE: 'finite' },
      form: {
        organization_id: defaultOrg,
        type: CONSTANTS.PRODUCT_TYPE ? CONSTANTS.PRODUCT_TYPE.TOUR : 'tour',
        code: `TOUR-REFERENCE-${Date.now()}`,
        base_price: 0,
        currency: 'VND',
        requires_prebook: true,
        capacity_mode: CONSTANTS.CAPACITY_MODE ? CONSTANTS.CAPACITY_MODE.UNLIMITED : 'unlimited'
      },
      rules: {
        base_price: [
          { required: true, message: 'Vui lòng nhập giá cơ bản', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.initOrgId()
  },
  methods: {
    initOrgId() {
      const org = getAccountOrg()
      const authInfo = loginInfo()
      if (org && (org.id || org._id)) {
        this.form.organization_id = org.id || org._id
      } else if (authInfo && authInfo.auth_user) {
        const user = authInfo.auth_user
        this.form.organization_id = user.organization_id || user.id || ''
      }
    },
    handleSetup() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.submitting = true

        const payload = {
          ...this.form,
          reference_id: this.detail ? (this.detail.id || this.detail._id) : null
        }

        createProduct(payload).then((res) => {
          const product = res.data || res
          this.$message.success('Thiết lập Booking thành công!')
          this.saveToLocale(product)
          this.$emit('setup-success', product)
        }).catch((err) => {
          const errMsg = (err && err.message) ? err.message : 'Có lỗi xảy ra khi tạo Product setup'
          this.$message.error(errMsg)
        }).finally(() => {
        }).finally(() => {
          this.submitting = false
        })
      })
    },
    saveToLocale(product) {
      if (!this.detail || (!this.detail.id && !this.detail._id)) return
      const detailId = this.detail.id || this.detail._id
      const productId = product.id || product._id || (product.data && product.data.id)

      let mappings = []
      try {
        const stored = localStorage.getItem('shared_booking_products')
        if (stored) mappings = JSON.parse(stored)
      } catch (e) {
        mappings = []
      }

      // Filter out existing mapping for detailId if any
      mappings = mappings.filter((item) => String(item.detail_id) !== String(detailId))
      mappings.push({
        detail_id: detailId,
        product_id: productId
      })

      localStorage.setItem('shared_booking_products', JSON.stringify(mappings))
    }
  }
}
</script>

<style scoped>
.booking-setup-form .title {
  font-size: 16px;
  color: #303133;
}
</style>
